import { Component, Input, Output, EventEmitter, ViewChild, OnChanges, SimpleChanges, ElementRef, AfterViewInit } from "@angular/core";
import { SlickSleepService } from "../utils/slick-sleep.service";
import { SlickUtilsService } from "../utils/slick-utils.service";
import { SlickTabHeaderComponent } from "./slick-tab-header.component";
import { ISlickTabModel } from "./slick-tab.model";
import { SlickTabsComponent } from "./slick-tabs.component";

@Component({
	selector: 'slick-tab',
	templateUrl: 'slick-tab.component.html'
})
export class SlickTabComponent implements OnChanges, AfterViewInit {
	@Input() header: string;
	@Input() icon: string;
	@Input() key: string;

	@ViewChild("tabHeaderRef") tabHeaderRef: SlickTabHeaderComponent;
	@ViewChild("tabBodyRef") tabBodyRef: ElementRef;

	uuid: string;
	showHeaderFromInput: boolean = false;
	selected: boolean = false;
	parentComponent: SlickTabsComponent;

	constructor(private el: ElementRef) {
		this.uuid = SlickUtilsService.newGuid();		
	}

	async ngAfterViewInit() {
		// Sleep to give this.parentComponent a chance to populate. When a <slick-tab> is created
		// dynamically (eg. inside an *ngIf, or inside a dialog opened from another dialog) the parent
		// SlickTabsComponent can take more than one cycle to register it, so retry a few times.
		for (let i = 0; i < 20 && !this.parentComponent; i++)
			await SlickSleepService.sleep();

		if (!this.parentComponent)
			return;

		// Remove this from the inline version and put it on the body so that it doesn't hide behind the bottom
		// of a div when it expands beyond the bottom.
		let displayBody = document.getElementById("slick-tab-display-body_" + this.parentComponent.uuid);
		if (displayBody)
			displayBody.appendChild(this.tabBodyRef.nativeElement);
	}

	async ngOnChanges(changes: SimpleChanges) {
		if (changes.header) {
			this.showHeaderFromInput = true;
			await SlickSleepService.sleep()

			if (this.tabHeaderRef) 
				this.tabHeaderRef.setHeader(changes.header.currentValue);			
		}

		if (changes.icon) {
			await SlickSleepService.sleep();

			if (this.tabHeaderRef)
				this.tabHeaderRef.setIcon(changes.icon.currentValue);
		}
	}

	async onTabClicked() {
		// If this is already selected, don't run the onTabSelected again.
		// This is causing double calls to the event
		if (this.selected)
			return;

		// parentComponent is wired up by SlickTabsComponent; if this tab was added late it may not be
		// set yet, so give it a few cycles before giving up rather than throwing.
		for (let i = 0; i < 20 && !this.parentComponent; i++)
			await SlickSleepService.sleep();

		if (!this.parentComponent)
			return;

		this.parentComponent.onTabSelected(this.uuid);
		this.selected = true;
	}
}
 